import { Theme } from '@mui/material/styles'

const useStyles = {
  informationSideBar: (theme: Theme) => ({
    maxWidth: '310px',
    padding: theme.spacing(3),
    border: '1px solid rgba(0, 0, 0, 0.05)',
    borderRadius: '12px',
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  }),
  companyLogo: (theme: Theme) => ({
    width: '100%',
    marginBottom: theme.spacing(1),
  }),
  superscript: { fontSize: '1.2rem' },
  timelineDotSuccess: (theme: Theme) => ({
    backgroundColor: `${theme.palette.success.light} !important`,
  }),
  timelineConnector: (theme: Theme) => ({
    backgroundColor: theme.palette.action.selected,
  }),
  addressContainer: (theme: Theme) => ({
    margin: theme.spacing(2, 0, 0, 0),
    padding: theme.spacing(1, 2),
    height: '100%',
    [theme.breakpoints.up('lg')]: {
      borderLeft: `1px solid ${theme.palette.action.selected}`,
    },
  }),
  installerContainer: (theme: Theme) => ({
    margin: theme.spacing(2, 0, 0, 0),
    padding: theme.spacing(1, 2),
  }),
  spacer: (theme: Theme) => ({
    height: theme.spacing(3),
  }),
  paDialogContent: {
    width: '600px',
  },
  subscriptionTitleGrid: (theme: Theme) => ({
    gap: theme.spacing(12),
    [theme.breakpoints.down(1351)]: {
      gap: theme.spacing(4),
    },
  }),
  subscriptionSubtitle: {
    lineHeight: 2,
  },
  subscriptionDetailsGrid: (theme: Theme) => ({
    gap: theme.spacing(14),
    [theme.breakpoints.down(956)]: {
      gap: theme.spacing(4),
    },
  }),
}

export default useStyles
